module.exports = __webpack_public_path__ + "img/版权监测ico.9be3c911.png";